module.exports = __webpack_public_path__ + "static/media/pp2j.4c2d725f.jpg";